// Facturation d'un contrat (04/10/2026), réglée auparavant dans Caisse › Paramètres › Sociétés.
// Mêmes colonnes : prefixe_reference_facture, num_bon_is_required, a_model_forfait, prix/qte/montant_forfait, duree_forfait.

export function formulaireFacturation(info) {
	const i = info || {}
	const texte = valeur => (valeur === null || valeur === undefined) ? '' : String(valeur)
	return {
		prefixe: texte(i.prefixe_reference_facture),
		// Comme dans la Caisse : jamais réglé = n° de bon obligatoire.
		num_bon_is_required: (i.num_bon_is_required === null || i.num_bon_is_required === undefined) ? 1 : Number(i.num_bon_is_required),
		a_model_forfait: Number(i.a_model_forfait) === 1 ? 1 : 0,
		duree_forfait: texte(i.duree_forfait),
		prix_unitaire_forfait: texte(i.prix_unitaire_forfait),
		qte_forfait: texte(i.qte_forfait),
	}
}

export function entierPositif(valeur) {
	return /^\d+$/.test(String(valeur === null || valeur === undefined ? '' : valeur).trim())
}

export function montantTotal(prix, qte) {
	return entierPositif(prix) && entierPositif(qte) ? Number(prix) * Number(qte) : null
}

export function nombre(valeur) {
	return (valeur === null || valeur === undefined || valeur === '') ? '—' : Number(valeur).toLocaleString('fr-FR')
}

// Résumé court pour une liste : « Forfait », « Bon obligatoire », « Préfixe 70 ».
export function resumeFacturation(info) {
	if (!info) return []
	const resume = []
	if (Number(info.a_model_forfait) === 1) resume.push('Forfait')
	if (info.num_bon_is_required === null || info.num_bon_is_required === undefined || Number(info.num_bon_is_required) === 1) resume.push('Bon obligatoire')
	if (info.prefixe_reference_facture) resume.push('Préfixe ' + info.prefixe_reference_facture)
	return resume
}
